import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { AlertService } from 'src/app/services/alert.service';

@Component({
  selector: 'app-risk-profile-incomplete',
  templateUrl: './risk-profile-incomplete.component.html'
})
export class RiskProfileIncompleteComponent implements OnInit {

  isApp: boolean = environment.app

  constructor(
    private dialogRef: MatDialogRef<RiskProfileIncompleteComponent>,
    private router: Router,
    private matDialog: MatDialog,
    private alertService: AlertService
  ) {
    this.alertService.getIsMobileDevice().subscribe((res: boolean) => {
      if (!environment.app) {
        this.isApp = res;
      }
    })
  }

  ngOnInit() {
  }

  goToProfile() {
    this.dialogRef.close()
    this.router.navigate(['/investor/profile/edit'])
  }

  showRiskProfile() {
    this.matDialog.closeAll()
    this.router.navigate(['/profile-completion'])
  }
  closeDialog() {
    this.matDialog.closeAll();
  }
}
